/**
 * Konfigurace store včetně middlewares.
 */

/* global __DEVTOOLS__ */
import {createStore, applyMiddleware, compose} from 'redux'
// reducer
import rootReducer from '../reducers/index'
// middleware
import thunkMiddleware from 'redux-thunk'
import promiseMiddleware from 'redux-promise'
import { createLogger } from 'redux-logger'

const {utils: { defaultImport }} = require("mc/lib");


const loggerMiddleware = createLogger({
    level: 'info',
    collapsed: true
});

// Pro vývoj si toto povolí jen ten, kdo ví k čemu to je a NEBUDE to commitovat!


let createStoreWithMiddleware;

if (typeof __DEV__ !== 'undefined' && __DEV__) {


    const middleware = [];
    middleware.push(thunkMiddleware);
    middleware.push(promiseMiddleware);
    middleware.push(loggerMiddleware);

    const composeEls = [];
    composeEls.push(applyMiddleware(...middleware));


    if (__DEVTOOLS__) {
        createStoreWithMiddleware = compose(...composeEls)(createStore);
    } else {
        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

        createStoreWithMiddleware = composeEnhancers(...composeEls)(createStore);
    }

} else {
    createStoreWithMiddleware = compose(
        applyMiddleware(thunkMiddleware, promiseMiddleware)
    )(createStore)
}

/**
 * Creates a preconfigured store.
 */
export default function configureStore(initialState) {
    console.debug("Konfigurace STORE");

    const store = createStoreWithMiddleware(rootReducer, initialState);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers/index', () => {
            const nextRootReducer = defaultImport(require('../reducers/index'));

            store.replaceReducer(nextRootReducer)
        })
    }

    return store
}
